module.exports = __webpack_public_path__ + "img/tractor_slurry.963c960b.jpeg";